module.exports = __webpack_public_path__ + "img/3.6fe922b9.png";